<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <vs-button @click="createBranch()" class="bg_l_green">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
        {{ $t("AddBranch") }}
      </vs-button>
      <div class="vx-row mt-4">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Name') },
              { title: 'شناسه ملی(شعبه)' },
              { title: 'کد اقتصادی(شعبه)' },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 30%">
                <span>
                  {{ row.companyName }}
                </span>
              </td>
              <td style="width: 20%">
                {{ row.companyNationalId }}
              </td>
              <td style="width: 20%">
                {{ row.economicCode }}
              </td>
              <td style="width: 25%; direction: ltr">
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  v-if="agentParentName != row.companyName"
                  @click="editBranch(row)"
                ></vs-button>
                <span v-else>
                  نماینده مرجع-امکان ویرایش در این صفحه وجود ندارد
                </span>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
      <add-branch-popup
        :show="isAddBranchPopup"
        :currentBranchData="currentBranchData"
        :agentParentId="agentParentId"
        :typePopup="typePopup"
        @finish="onfinish"
      ></add-branch-popup>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import AddBranchPopup from "./AddBranchPopup";
export default {
  name: "",
  data() {
    return {
      currentBranchData: {},
      isAddBranchPopup: false,
      agentParentId: this.$route.params.id,
      agentParentName:
        this.$route.query.breadcrumbNameManual.persianTitleParent,
      typePopup: "create",
      gridDataSource: {
        type: "app",
        service: "BusinessParties/api/AgentsInfoQuery/id/who-has-branch",
      },
      gridSearchData: {
        id: this.$route.params.id,
      },
    };
  },
  components: {
    DataGrid,
    AddBranchPopup,
  },
  methods: {
    createBranch() {
      this.currentBranchData = {};
      this.typePopup = "create";
      this.isAddBranchPopup = true;
    },
    editBranch(data) {
      this.currentBranchData = data;
      this.typePopup = "edit";
      this.isAddBranchPopup = true;
    },
    onfinish() {
      this.isAddBranchPopup = false;
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
